import { Button, type ButtonProps } from "@chakra-ui/react";
import { ColorScheme, SizeType, ButtonVariant } from '@/types'
import React from "react";

interface Props extends ButtonProps {
  colorScheme?: ColorScheme,
  variant?: ButtonVariant,
  size?: SizeType,
};

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <Button ref={ref} { ...props } />
  )
})


export {
  Component as Button,
  type Props as ButtonProps,
}